// pages/messenger/messenger-jobdone.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import RequestService from '../../services/requestService';

const MessengerJobDone = () => {
    const navigate = useNavigate();
    const { id: encodedId, seq: encodedSeq, total: encodedTotal } = useParams();
    const id         = atob(encodedId);
    const seq        = encodedSeq  ? Number(atob(encodedSeq))   : 1;
    const totalStops = encodedTotal ? Number(atob(encodedTotal)) : 1;

    const [job, setJob] = useState(null);

    useEffect(() => {
        const fetchJob = async () => {
            try {
                const resp = await RequestService.GetRequestById(id);
                if (resp?.data?.is_success === true) {
                    setJob(resp.data.result);
                }
            } catch (err) {
                console.error(err);
            }
        };
        fetchJob();
    }, [id]);

    const now = new Date().toLocaleTimeString('th-TH', {
        hour: '2-digit', minute: '2-digit',
    });

    const details      = job?.request_details || [];
    const pendingStops = details.filter(d => d.is_complete != 1);
    const hasNext      = pendingStops.length > 0;
    const isAllDone    = pendingStops.length === 0;
    const doneCount    = details.filter(d => d.is_complete == 1).length;

    const handleNext = () => {
        const nextStop = details.find(d => d.is_complete != 1);
        if (!nextStop) {
            navigate('/messenger/myjob', { replace: true });
            return;
        }
    
        // เพิ่ม seq ของ stop ถัดไปลง sessionStorage ก่อน navigate
        try {
            const stored = sessionStorage.getItem(`started_${id}`);
            const seqs = stored ? JSON.parse(stored) : [];
            if (!seqs.includes(nextStop.seq)) {
                seqs.push(nextStop.seq);
                sessionStorage.setItem(`started_${id}`, JSON.stringify(seqs));
            }
        } catch {}
    
        navigate(
            `/messenger/job-overview/${btoa(id)}`,
            { replace: true }
        );
    };

    // title
    const title = totalStops === 1
        ? 'ส่งสำเร็จ!'
        : isAllDone
        ? 'ส่งครบทั้งหมดแล้ว'
        : 'ส่งสำเร็จ!';

    // แสดง ref_no ถ้า stop เดียว หรือหลาย stop แต่ยังไม่ครบ
    const showRef = totalStops === 1 || !isAllDone;

    return (
        <div className="mjdone-root">
            <div className="mjdone-content">

                {/* icon ใหญ่ — stop เดียวเท่านั้น */}
                {totalStops === 1 && (
                    <div className="mjdone-icon">
                        <i className="mdi mdi-map-marker-check" />
                    </div>
                )}

                {/* stepper — หลาย stop เท่านั้น */}
                {totalStops > 1 && (
                    <div className="mjdone-steps">
                        {Array.from({ length: totalStops }).map((_, i) => {
                            const isDone     = i < doneCount;
                            const nextIsDone = i + 1 < doneCount;

                            return (
                                <React.Fragment key={i}>
                                    {isDone
                                        ? <i className="mdi mdi-map-marker-check mjdone-step-icon mjdone-step-icon--done" />
                                        : <i className="ri ri-record-circle-fill mjdone-step-icon mjdone-step-icon--pending" />
                                    }
                                    {i < totalStops - 1 && (
                                        <div className={`mjdone-step-line ${isDone && nextIsDone ? 'mjdone-step-line--done' : ''}`} />
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </div>
                )}

                <p className="mjdone-title">{title}</p>

                {showRef && (
                    <p className="mjdone-ref">Ref No. {job?.ref_no || '-'}</p>
                )}

                <p className="mjdone-time">เสร็จสมบูรณ์ เวลา {now} น.</p>

            </div>

            <div className="mjdone-footer">
                {hasNext ? (
                    <>
                        <button className="mjdone-btn" onClick={handleNext}>
                            ไปคำขอถัดไป
                        </button>
                        <button
                            className="mjdone-btn mjdone-btn--ghost"
                            onClick={() => navigate('/messenger/myjob', { replace: true })}
                        >
                            <i className='mdi mdi-undo-variant'></i>
                            ไปหน้างานของฉัน
                        </button>
                    </>
                ) : (
                    <button
                        className="mjdone-btn"
                        onClick={() => navigate('/messenger/myjob', { replace: true })}
                    >
                        <i className='mdi mdi-undo-variant'></i>
                        ไปหน้างานของฉัน
                    </button>
                )}
            </div>
        </div>
    );
};

export default MessengerJobDone;